import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CHANGE_DISPLAY_LOBBY, CHANGE_DISPLAY_OFFLINE, CHANGE_DISPLAY_ONLINE, CHANGE_DISPLAY_PARTICIPANE, CHANGE_DISPLAY_RAISED_HAND, CHANGE_TAB_PARTICIPANT, DATA_ATTENDANCE, PARTICIPANTS_PANE_CLOSE, PARTICIPANTS_PANE_OPEN, SET_VOLUME } from './actionTypes';
import { REDUCER_KEY } from './constants.any';
const DEFAULT_STATE = {
    isOpen: false,
    participantsVolume: {},
    dataAttendance: [],
    tabLeftParticipant: true,
    isDisplayLobby: true,
    isDisplayParticipated: true,
    isDisplayOnline: true,
    isDisplayOffline: true,
    isDisplayRaisedHand: true
};
/**
 * Listen for actions that mutate the participants pane state.
 */
ReducerRegistry.register(REDUCER_KEY, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case PARTICIPANTS_PANE_CLOSE:
            return {
                ...state,
                isOpen: false
            };
        case PARTICIPANTS_PANE_OPEN:
            return {
                ...state,
                isOpen: true
            };
        case SET_VOLUME:
            return {
                ...state,
                participantsVolume: {
                    ...state.participantsVolume,
                    [action.participantId]: action.volume
                }
            };
        case CHANGE_TAB_PARTICIPANT:
            return {
                ...state,
                tabLeftParticipant: action.payload
            };
        case CHANGE_DISPLAY_LOBBY:
            return {
                ...state,
                isDisplayLobby: action.payload
            };
        case CHANGE_DISPLAY_PARTICIPANE:
            return {
                ...state,
                isDisplayParticipated: action.payload
            };
        case CHANGE_DISPLAY_RAISED_HAND:
            return {
                ...state,
                isDisplayRaisedHand: action.payload
            };
        case CHANGE_DISPLAY_ONLINE:
            return {
                ...state,
                isDisplayOnline: action.payload
            };
        case CHANGE_DISPLAY_OFFLINE:
            return {
                ...state,
                isDisplayOffline: action.payload
            };
        case DATA_ATTENDANCE:
            return {
                ...state,
                dataAttendance: action.payload
            };
        default:
            return state;
    }
});
